/**
 * Safe internal redirect path from ?redirect= query (guest post links, etc.).
 * @param {string|import('vue-router').LocationQueryValue[]|null|undefined} raw
 * @returns {string|null}
 */
export function parseSafeRedirectPath(raw) {
  if (typeof raw !== 'string' || !raw.trim()) return null;
  let path = raw.trim();
  if (!path.startsWith('/') || path.startsWith('//')) return null;
  // Allow ?redirect=/post/id?foo=bar — keep pathname + search only (no hash)
  try {
    const url = new URL(path, 'http://local');
    path = `${url.pathname}${url.search}`;
  } catch {
    return null;
  }
  if (!path.startsWith('/') || path.startsWith('//')) return null;
  return path;
}

/**
 * After auth, navigate to full post detail when redirect targets /post/:id.
 * @param {import('vue-router').Router} router
 * @param {string|null} redirectPath
 */
export async function navigateAfterAuth(router, redirectPath) {
  const pathOnly = redirectPath?.split('?')[0] ?? '';
  if (pathOnly.startsWith('/post/')) {
    const postId = pathOnly.slice('/post/'.length).split('/')[0]?.trim();
    if (postId) {
      await router.replace({ name: 'social.post-detail', params: { postId } });
      return;
    }
  }
  if (pathOnly.startsWith('/market/article-detail/')) {
    const articleId = pathOnly.slice('/market/article-detail/'.length).split('/')[0]?.trim();
    if (articleId) {
      await router.replace({ name: 'market.article-detail', params: { articleId } });
      return;
    }
  }
  if (pathOnly === '/market/for-you' || pathOnly === '/market') {
    await router.replace({ name: 'market.for-you' });
    return;
  }
  if (redirectPath) {
    await router.replace(redirectPath);
    return;
  }
  await router.replace({ path: '/' });
}
